<template>
	<v-row class="px-4">
		<v-col md="3" class="my-auto py-0" v-if="false">
			<label for="display-name" class="btx-label mt-2 required">Address Type </label>
		</v-col>
		<v-col md="9" class="py-0" v-if="false">
			<v-radio-group v-model="address.address_type" row hide-details class="ma-0">
				<v-radio label="Billing Address" :value="1" class="mr-3" color="blue darken-4"></v-radio>
				<v-radio label="Shipping Address" :value="2" class="ma-0" color="blue darken-4"></v-radio>
			</v-radio-group>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="address-label" class="btx-label mt-2 required">Label </label>
		</v-col>
		<v-col md="9" class="py-0">
			<TextInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="address-label"
				placeholder="Label"
				v-model="address.label"
				:rules="[vrules.required(address.label, 'Label')]"
				:class="{ required: !address.label }"
			></TextInput>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="display-name" class="btx-label mt-2 required">Contact Person </label>
		</v-col>
		<v-col md="9" class="py-0">
			<AutoCompleteInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="contact-person"
				placeholder="Contact Person"
				v-model="address.contact_person"
				:items="personList"
				item-text="display_name"
				item-value="id"
				:rules="[vrules.required(address.contact_person, 'Contact Person')]"
				:class="{ required: !address.contact_person }"
			></AutoCompleteInput>
		</v-col>

		<v-col md="3" class="my-auto py-0">
			<label for="postal-code" class="btx-label mt-2 text-right required">Postal Code </label>
		</v-col>
		<v-col md="9" class="py-0">
			<v-text-field
				outlined
				class="mt-3"
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="postal-code"
				placeholder="Postal Code"
				type="number"
				v-mask="'######'"
				v-model="address.address_postal_code"
				:rules="[
					vrules.required(address.address_postal_code, 'address postal code'),
					vrules.phoneNumber(address.address_postal_code, 'address postal code', 6),
				]"
				:class="{
					required: !address.address_postal_code,
				}"
			></v-text-field>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="address-line-1" class="btx-label mt-2 required">Address Line 1 </label>
		</v-col>
		<v-col md="9" class="py-0">
			<TextInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				:rules="[vrules.required(address.address_line_1, 'Address line 1')]"
				:class="{ required: !address.address_line_1 }"
				id="address-line-1"
				placeholder="Address Line 1"
				v-model="address.address_line_1"
			></TextInput>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="address-line-2" class="btx-label mt-2">Address Line 2 </label>
		</v-col>
		<v-col md="9" class="py-0">
			<TextInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="address-line-2"
				placeholder="Address Line 2"
				v-model="address.address_line_2"
			></TextInput>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="unit-number" class="btx-label mt-2">Unit No. </label>
		</v-col>
		<v-col md="9" class="py-0">
			<TextInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="unit-number"
				placeholder="Unit No."
				v-model="address.unit_number"
			></TextInput>
		</v-col>
		<v-col md="3" class="my-auto py-0">
			<label for="address-country" class="btx-label mt-2">Country</label>
		</v-col>
		<!-- <pre>
			{{ address }}
		</pre> -->
		<v-col md="9" class="py-0">
			<TextInput
				hide-details
				:disabled="pageLoading"
				:loading="pageLoading"
				id="address-country"
				placeholder="Country"
				v-model="address.address_country"
			></TextInput>
		</v-col>
	</v-row>
</template>
<script>
import { mapGetters } from "vuex";
import TextInput from "@/view/components/TextInput";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";

import ApiService from "@/core/services/api.service";
import { isObject, isEqual } from "lodash";

export default {
	name: "btx-address",
	title: "Address",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			type: [Object, String],
			default: null,
		},
		isLocation: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		type: {
			type: Number,
			default: 1,
		},
		uuid: {
			type: String,
			default: null,
		},
		customerId: {
			type: [Number, String],
			default: null,
		},
		newAddress: {
			type: Boolean,
			default: false,
		},
		personList: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	data() {
		return {
			countries: [],
			states: [],
			cities: [],
			companyNameError: null,
			contactPersons: [],
			locationList: [],
			countryLoading: false,
			contactPersonDialog: false,
			stateLoading: false,
			cityLoading: false,
			pageLoading: false,
			address: {
				id: null,
				uuid: null,
				address_type: 1,
				contact_person: 1,
				name: null,
				display_name: null,
				company_name: null,
				phone_no: null,
				email: null,
				location: null,
				address_line_1: null,
				address_line_2: null,
				address_country: "Singapore",
				address_postal_code: null,
				unit_number: null,
				label: null,
			},
		};
	},
	watch: {
		address: {
			deep: true,
			handler(param) {
				this.$emit("input", param);
			},
		},
		value: {
			deep: true,
			handler() {
				this.updateAddress();
			},
		},
	},
	methods: {
		getContactPersonList() {
			this.$emit("updateContactPersonList", true);
		},
		updateAddress() {
			if (isObject(this.value) && !isEqual(this.value, this.address)) {
				this.address = {
					id: this.value.id || null,
					uuid: this.value.uuid || null,
					contact_person: this.value.contact_person || null,
					name: this.value.name || null,
					display_name: this.value.name || null,
					unit_number: this.value.unit_number || null,
					company_name: this.value.company_name || null,
					phone_no: this.value.phone_no || null,
					email: this.value.email || null,
					location: this.value.location || null,
					address_line_1: this.value.address_line_1 || null,
					address_line_2: this.value.address_line_2 || null,
					address_state: this.value.address_state || null,
					address_country: this.value.address_country || null,
					address_postal_code: this.value.address_postal_code || null,
					label: this.value.label || null,
				};
			}
			this.$nextTick(() => {
				if (this.address.address_country) {
					// this.getStates();
					// if (this.address.address_state) {
					// 	this.getCities();
					// }
				}
			});
		},
		getCountries() {
			const countries = localStorage.getItem("countries");
			if (countries) {
				this.countries = JSON.parse(countries);
			} else {
				this.countries = [
					{
						name: "Singapore",
						code: "SG",
						dial_code: "+65",
					},
				];
				localStorage.setItem("countries", JSON.stringify(this.countries));
			}
		},
		getStates() {
			const { address_country } = this.address;
			const key = `states-${address_country}`.toLowerCase();
			const state = localStorage.getItem(key);
			if (state) {
				this.states = JSON.parse(state);
			} else {
				if (this.stateLoading) {
					return false;
				}
				this.stateLoading = true;
				ApiService.post("https://countriesnow.space/api/v0.1/countries/states", {
					country: address_country,
				})
					.then(({ data }) => {
						const { states } = data;
						this.states = states;
						localStorage.setItem(key, JSON.stringify(states));
					})
					.catch((error) => {
						console.log({ error });
					})
					.finally(() => {
						this.stateLoading = false;
					});
			}
		},
		getCities() {
			const { address_country, address_state } = this.address;
			const key = `cities-${address_country}-${address_state}`.toLowerCase();
			const cities = localStorage.getItem(key);
			if (cities) {
				this.cities = JSON.parse(cities);
			} else {
				if (this.cityLoading) {
					return false;
				}
				this.cityLoading = true;
				ApiService.post("https://countriesnow.space/api/v0.1/countries/state/cities", {
					country: address_country,
					state: address_state,
				})
					.then(({ data }) => {
						this.cities = data;
						localStorage.setItem(key, JSON.stringify(data));
					})
					.catch((error) => {
						console.log({ error });
					})
					.finally(() => {
						this.cityLoading = false;
					});
			}
		},
	},
	components: {
		TextInput,
		AutoCompleteInput,
	},
	computed: {
		...mapGetters(["localDB"]),
		stringId() {
			return this.stringUnique();
		},
	},
	mounted() {
		this.locationList = this.localDB("locations", []);
		this.updateAddress();
		this.getCountries();
		//this.address.address_country = "Singapore";
	},
};
</script>
